import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { select } from 'd3'
// import { Tooltip } from 'antd'

// Create Event Handlers for mouse

class LedStatus extends Component {
  componentDidMount () {
    let svgElement = this.refs.svg
    let x = this.props.width || 60
    let y = x
    let radius = x < y ? x / 3 : y / 3
    this.onColor = this.props.onColor
    this.offColor = this.props.offColor

    let svg = select(svgElement).attr('width', x).attr('height', y)

    svg.append('circle')
      .attr('cx', x / 2 - radius)
      .attr('cy', y / 2 + radius)
      .attr('r', radius / 3)
      .attr('isOn', false)
      .style('fill', this.onColor)

    svg.append('circle')
      .attr('cx', x / 2 + radius)
      .attr('cy', y / 2 + radius)
      .attr('r', radius / 3)
      .attr('isOn', false)
      .style('fill', this.offColor)

    this.led = svg.append('circle')
      .attr('cx', x / 2)
      .attr('cy', y / 2)
      .attr('r', radius)
      .style('fill', this.props.isOn ? this.onColor : this.offColor)

    svg.append('text')
      .text(this.props.tittle.split(' ').map((el) => el[0]).join(''))
      .attr('x', x / 2)
      .attr('y', y / 2 + radius * 0.7 / 3)
      .attr('font-family', 'sans-serif')
      .attr('font-size', `${radius * 0.7}px`)
      .attr('fill', 'white')
      .attr('stroke', 'white')
      .style('text-anchor', 'middle')
  }

  componentWillReceiveProps (props) {
    this.led
      .transition()
      .style('fill', props.isOn ? this.onColor : this.offColor)
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    return (

      <svg
        ref='svg'
        height={this.props.width}
      />

    )
  }
}

LedStatus.propTypes = {
  title: PropTypes.string,
  isOn: PropTypes.number,
  onColor: PropTypes.string,
  offColor: PropTypes.string,
  width: PropTypes.number
}

export default LedStatus



// WEBPACK FOOTER //
// ./src/charts/LedStatus.js